import { HisWidgetBase } from '../model/his-widget-base';
import { HisOption } from '../model/his-option';
import { HisWidgetGroup } from '../model/his-widget-group';
import { HisStringUtils } from '../../core/utils';
import { HisSearchConstants } from '../model/search/his-search-constants';

export class HisWidgetUtils {

    public static getWidgetGroupWithLabel(groupLabel: string, widgetGroups: HisWidgetGroup[]): HisWidgetGroup {
        for (let widgetGroup of widgetGroups) {
            if (widgetGroup.label === groupLabel) {
                return widgetGroup;
            }
        }
        return undefined;
    }

    public static getWidgetGroupContainingWidgetWithId(id: string, widgetGroups: HisWidgetGroup[]): HisWidgetGroup {
        for (let widgetGroup of widgetGroups) {
            let widget = HisWidgetUtils.getWidgetWithIdFromGroup(id, widgetGroup);
            if (widget) {
                return widgetGroup;
            }
        }
        return undefined;
    }

    public static getWidgetWithIdFromWidgetGroups(id: string, widgetGroups: HisWidgetGroup[]): HisWidgetBase<any> {
        for (let widgetGroup of widgetGroups) {
            if (id.startsWith('EXIST')) {
                // widget.id: de.his.javang.suchen.personendaten[0]CONCAT(Person.firstname,' ',Person.surname)
                // id: EXIST_de_his_javang_suchen_personendaten_1:CONCAT(Person.firstname,' ',Person.surname)
                // group.label: de.his.javang.suchen.personendaten
                // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #id', id);
                // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #widgetGroup', widgetGroup);
                let tmp = id.replace('EXIST_', '');
                tmp = HisStringUtils.replaceAll(tmp, '_', '.');
                // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #tmp', tmp);
                if (tmp.startsWith(widgetGroup.label)) {
                    // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #widgetGroup', widgetGroup);
                    tmp = tmp.replace(widgetGroup.label, '').replace('.', '');
                    let index = tmp.substring(0, tmp.indexOf(':'));
                    // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #tmp', index);
                    let path = tmp.replace(index + ':', '');
                    // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #path', path);
                    let widgetId = widgetGroup.label + '[' + index + ']' + path;
                    // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #widgetId', widgetId);

                    for (let criteriaGroup of widgetGroup.criteriaGroups) {
                        // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #criteriaGroup', criteriaGroup);
                        for (let criteriaGroupWidget of criteriaGroup.widgets) {
                            if (criteriaGroupWidget.id === widgetId) {
                                // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #criteriaGroupWidget.id', widget.id);
                                return criteriaGroupWidget;
                            }
                        }
                    }
                }
            }

            let widget = HisWidgetUtils.getWidgetWithIdFromGroup(id, widgetGroup);
            if (widget === null) {
                continue;
            }
            return widget;
        }
        return null;
    }

    public static getWidgetWithIdFromGroup(id: string, widgetGroup: HisWidgetGroup): HisWidgetBase<any> {
        for (let widget of widgetGroup.widgets) {
            if (widget.id === id) {
                return widget;
            }
        }
        return null;
    }

    public static getOptionIds(options: HisOption[]): string[] {
        let optionIds: string[] = [];
        if (options === null || options === undefined) {
            return optionIds;
        }

        for (let opt of options) {
            let id: string = opt.id;
            optionIds.push(id);
        }

        return optionIds;
    }

    public static parseArrayString(value: string): string[] {
        // let valueArray: string[] = JSON.parse( value ); // does not work for ids of tree elements with subtree like "3x"
        let valueWithoutBrackets = value.startsWith('[') && value.endsWith(']') ? value.substring(1, value.length - 1) : value;
        let valueArray: string[] = valueWithoutBrackets.split(',');
        return valueArray;
    }

    public static getCriteriaGroupIndexForKey(key: string): number {
        // groups0.criteriaGroups0.criteria0.field
        let index1 = key
            .substring(key.indexOf(HisSearchConstants.CRITERIA_GROUPS))
            .replace(HisSearchConstants.CRITERIA_GROUPS, '');
        // console.log('his-search-parser#keyCriteriaGroupIndex() #index1', index1);
        let index2 = index1.substring(0, index1.indexOf('.'));
        // console.log('his-search-parser#keyCriteriaGroupIndex() #index2', index2);
        return Number(index2);
    }

    public static getCriteriaGroupIndexForWidgetId(widgetId: string): number {
        // let tmp = 'de.his.psv.Personbla[0]Person.gender.id';
        // console.log('his-search-parser#widgetIdCriteriaGroupIndex() #widgetId', widgetId);
        let index = widgetId.substring(widgetId.indexOf('[') + 1, widgetId.indexOf(']'));
        if (HisStringUtils.isBlank(index)) {
            // console.log('his-search-parser#widgetIdCriteriaGroupIndex() #index', -1);
            return -1;
        }
        // console.log('his-search-parser#widgetIdCriteriaGroupIndex() #index', Number(index));
        return Number(index);
    }

    /**
     * Prüft, ob der key (aus den params, flat object url format) zur widgetId passt, also ob beide das gleiche Feld vertreten
     *
     * @returns true, if the key represents the widget, false otherwise
     */
    public static isMatchingKeyForWidget(key: string, value: string, widgetId: string, groupLabel: string): boolean {

        // #key groups0.criteria0.field
        if (!key.endsWith('.' + HisSearchConstants.FIELD)) {
            return false;
        }
        // #value Person.gender.id
        if (widgetId !== value) {
            // console.log('his-widget-utils#isMatchingKeyForWidget(), #widgetId !== value', widgetId !== value);
            return false;
        }

        let isCriteriaGroupWidget = widgetId.startsWith(groupLabel);
        let isCriteriaGroupKey = key.includes(HisSearchConstants.CRITERIA_GROUPS);
        if (!isCriteriaGroupWidget && !isCriteriaGroupKey) {
            // Es sind beide keine Kriteriengruppen Element,
            // dann reichen obige Bedingungen aus
            return true;
        }

        let isCriteriaGroup = isCriteriaGroupWidget && isCriteriaGroupKey;
        let isCriteriaGroupId =
            HisWidgetUtils.getCriteriaGroupIndexForKey(key) === HisWidgetUtils.getCriteriaGroupIndexForWidgetId(widgetId);

        // groups0.criteriaGroups0.criteria0.field
        if (isCriteriaGroup && isCriteriaGroupId) {
            // Es ist das richtige Kriteriengruppen Feld
            return true;
        }
        // console.log('his-widget-utils#isMatchingKeyForWidget(), #no result', widgetId);
        return false;
    }

    /**
     * Gets the preset value for the widget in case of flat object url format
     */
    public static getPresetForWidget(widget: HisWidgetBase<any>, presets: any): any {
        // console.log('his-search-parser#getPresetForWidget() #widget', widget, '#presets', presets);
        for (let key of Object.keys(presets)) {
            let fieldValue = presets[key];
            if (!key.endsWith('.' + HisSearchConstants.FIELD)) {
                continue;
            }

            // if (key.endsWith('.' + HisSearchParser.FIELD) && widget.id === fieldValue) {
            if (this.isWidgetForKey(key, fieldValue, widget)) {
                let valueKey = key.replace(HisSearchConstants.FIELD, HisSearchConstants.VALUE);
                // groups0.criteriaGroups0.criteria0.value
                console.log('his-search-parser#getPresetForWidget() #valueKey', valueKey, '#value', presets[valueKey]);
                if (valueKey && presets[valueKey]) {
                    // Checkboxen
                    // groups0.criteria0.value=<>ISNULL, jdoech widget.value=true (boolean)
                    if (widget.kind === 'checkbox') {
                        console.log('his-search-parser#getPresetForWidget() #preset to return', true);
                        return true;
                    }

                    // groups0.criteria0.value=2
                    let preset = presets[valueKey];
                    console.log('his-search-parser#getPresetForWidget() #preset to return', preset);
                    return preset;
                }
            }
        }
    }

    private static isWidgetForKey(key: string, value: any, widget: HisWidgetBase<any>) {
        // console.log('his-search-parser#isWidgetForKey() #key', key);
        if (!key.endsWith('.' + HisSearchConstants.FIELD)) {
            return false;
        }
        if (widget.id !== value) {
            return false;
        }
        // console.log('his-search-parser#isWidgetForKey() #widget', widget);
        if (
            key.includes(HisSearchConstants.CRITERIA_GROUPS)
            && HisWidgetUtils.getCriteriaGroupIndexForKey(key) !== HisWidgetUtils.getCriteriaGroupIndexForWidgetId(widget.id)) {
            return false;
        }
        return true;
    }

    /**
     * Checks if the provided value represents at least one actual selection. This evaluates to false for:
     * - `null` or `undefined`
     * - empty strings (`''`)
     * - nullish objects (e.g., `{}`, `{ id: null }`, `{ id: undefined }`, `{ id: '' }`)
     * - arrays that are empty (`[]`) or only contain nullish objects (as defined above)
     * @param val the value to check
     * @returns `false` for all specified non-actual selections, `true` otherwise
     */
    public static isActualSelection(val: any) {
        if (HisWidgetUtils.isNullishSelection(val)) {
            return false;
        }

        if (Array.isArray(val)) {
            return HisWidgetUtils.isActualSelectionArray(val);
        }

        return HisWidgetUtils.isActualSelectionObject(val);
    }

    /**
     * Checks if the provided array contains at least one actual selection.
     * @param vals - the array of values to check
     * @returns `true` if at least one actual selection is found, `false` otherwise
     */
    private static isActualSelectionArray(vals: any[]): boolean | any {
        // filter out non-actual selection objects; if at least one remains, we have an actual selection
        const filteredVals = vals.filter(v => HisWidgetUtils.isActualSelectionObject(v));
        return filteredVals.length > 0;
    }

    /**
     * Checks if the provided object represents an actual selection.
     * @param val - the object to check
     * @returns `true` if the object has a truthy `id` property, `false` otherwise
     */
    private static isActualSelectionObject(val: any): boolean {
        if (typeof val === 'object') {
            // none null id is necessary to identify criteria value as HisOption
            return !HisWidgetUtils.isNullishSelection(val?.id); // val could be null, as it counts to type object too
        }
        return !HisWidgetUtils.isNullishSelection(val);
    }

    /**
     * Checks if the provided value is nullish. Here, `nullish` includes empty strings, as the generic search considers them as null values
     * and they are semantically represented by `'ISNULL'` in actual search constraints.
     */
    private static isNullishSelection(val: any): boolean {
        return val === null || val === undefined || val === '';
    }

}
